import { useEffect, useLayoutEffect, useRef, useState } from "react";
import "./quoteLinkContextMenu.css";
import { CopyIcon, SendIcon } from "../../assets";
import { Modal } from "react-bootstrap";
import { axiosInstance } from "../../redux/constants/axiosInstance";
import { API_URL } from "../../redux/constants/type";
import { handleGeneralNotification } from "../../utils/helpers/notifications";
import Loader from "../../components/Dailogs/Loader";
import { ROLES } from "../../utils/helpers/userRole";

const QuoteLinkContextMenu = ({ children, quoteid, quoteLink }) => {
  const [open, setOpen] = useState(false);
  const [showModel, setShowModel] = useState(false);
  const contextRef = useRef(null);
  const [textEmail, setTextEmail] = useState("");
  const [modalLoading, setModalLoading] = useState(false);
  const roleAccess = window.localStorage.getItem("roleid");
  useEffect(() => {
    if (open) {
      document.addEventListener("click", offClickHandler);
      document.addEventListener("contextmenu", offClickHandler);
    } else {
      document.removeEventListener("click", offClickHandler);
      document.removeEventListener("contextmenu", offClickHandler);
    }

    return () => {
      document.removeEventListener("click", offClickHandler);
      document.removeEventListener("contextmenu", offClickHandler);
    };
  }, [open]);

  const offClickHandler = (event) => {
    if (contextRef.current && !contextRef.current.contains(event.target)) {
      setOpen(false);
    }
  };

  const handleRightClick = (event) => {
    event.preventDefault();
    setOpen(true);
  };

  const handleCopyLink = (event) => {
    event.preventDefault();
    navigator.clipboard.writeText(quoteLink);
    setOpen(false);
  };

  const handleSendClientEmail = (event) => {
    event.preventDefault();
    setShowModel(true);
    setOpen(false);
    setModalLoading(true);
    axiosInstance
      .get(`${API_URL}/api/quote/${quoteid}/get-email-to-send-quote`)
      .then((res) => {
        if (res.data.status) {
          setTextEmail(res.data.data);
        }
        setModalLoading(false);
      });
  };

  const handleNoClick = () => {
    setTextEmail("");
    setShowModel(false);
  };

  const handleSendClick = (event) => {
    event.preventDefault();
    if (textEmail) {
      let params = {
        quoteId: quoteid,
        email: textEmail,
      };
      axiosInstance
        .post(`${API_URL}/api/quote/send-email`, params)
        .then((res) => {
          if (res.data.status) {
            setTextEmail("");
            setShowModel(false);
            handleGeneralNotification(
              {
                notificationType: "CUSTOM",
                text: "Email was successfully sent.",
              },
              false
            );
          }
        });
    }
  };

  return (
    <>
      <div
        className="position-relative"
        onContextMenu={handleRightClick}
        ref={contextRef}
      >
        {children}
        {quoteLink && open && (
          <>
            {roleAccess !== ROLES.VIEWER && roleAccess !== ROLES.USER && (
              <div className="quote-context-menu">
                <div
                  className="quote-context-menu-item"
                  onClick={handleCopyLink}
                >
                  <div className="menu-item-icon">
                    <CopyIcon />
                  </div>
                  <div className="menu-item-label">Copy link</div>
                </div>
                <div
                  className="quote-context-menu-item"
                  onClick={handleSendClientEmail}
                >
                  <div className="menu-item-icon">
                    <SendIcon />
                  </div>
                  <div className="menu-item-label">Send to client's email</div>
                </div>
              </div>
            )}
          </>
        )}
      </div>
      <Modal show={showModel} centered className="quote-send-email-modal">
        <Modal.Body>
          {modalLoading && (
            <div className="position-absolute h-100 w-100 d-flex align-items-center justify-content-center">
              <Loader />
            </div>
          )}
          <form
            className="d-flex flex-column align-items-center justify-content-between h-100"
            onSubmit={handleSendClick}
          >
            <div>
              You are going to send the quote for review and signing to the
              client's email:
            </div>
            <div className="w-100">
              <input
                type="email"
                className="borderless-input"
                value={textEmail}
                onChange={(e) =>
                  setTextEmail(e.target.value.toLowerCase().trim())
                }
              />
            </div>
            <div>Do you want to continue?</div>
            <div className="d-flex justify-content-evenly w-100">
              <button className="action-button-no" onClick={handleNoClick}>
                No
              </button>
              <button
                className="action-button-send"
                type="submit"
                disabled={!Boolean(textEmail)}
              >
                Send
              </button>
            </div>
          </form>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default QuoteLinkContextMenu;
